import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { AccountingBillActions } from ".";
import { initialAccountingBillState } from "./Bill.types";
import {
  CLEAR_ACCOUNTING_BILL,
  FETCH_ACCOUNTING_BILL_FAILURE,
  FETCH_ACCOUNTING_BILL_LIST_FAILURE,
  FETCH_ACCOUNTING_BILL_LIST_PROGRESS,
  FETCH_ACCOUNTING_BILL_LIST_SUCCESS,
  FETCH_ACCOUNTING_BILL_PROGRESS,
  FETCH_ACCOUNTING_BILL_SUCCESS,
} from "./BillActions";

export const AccountingBillReducer = (
  state: IStoreState["accounting"]["bill"] = initialAccountingBillState,
  action: AccountingBillActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_BILL_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_BILL_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_ACCOUNTING_BILL: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialAccountingBillState.data;
        draftState.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
